export default "__VITE_ASSET__Dcmwpo2d__"